export default "__VITE_ASSET__BcMOO58D__"